import { render } from "./NotificationSummary.vue?vue&type=template&id=5cf13944"
import script from "./NotificationSummary.vue?vue&type=script&lang=js"
export * from "./NotificationSummary.vue?vue&type=script&lang=js"

import "./NotificationSummary.vue?vue&type=style&index=0&id=5cf13944&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__